// Resolves the guest-app base URL used by feed/IRD preview iframes.
// Priority (highest first):
//   1. ?guestAppUrl=... query param (auto-persisted to localStorage)
//   2. localStorage 'guestAppUrl' (persisted QA override; auto-purged if stale alpha-*)
//   3. Domain-derived: <brand>-console.X → <brand>.X
//   4. process.env.REACT_APP_GUEST_APP_BASE_URL (build-time)
//   5. Hardcoded prod/dev fallback (legacy safety net)

function deriveFromHost() {
    const host = typeof window !== 'undefined' ? window.location.hostname : '';
    if (host.includes('-console.')) {
        return `${window.location.protocol}//${host.replace('-console.', '.')}`;
    }
    return null;
}

// Auto-purge stale localStorage values from old alpha-* migration testing
function purgeStaleStorage() {
    if (typeof window === 'undefined') return;
    try {
        const v = localStorage.getItem('guestAppUrl');
        // alpha-* DNS records were deleted post-cutover (2026-05-04).
        // Any stored value pointing there is broken — discard it.
        if (v && (v.includes('alpha-') || v.includes('://alpha.'))) {
            localStorage.removeItem('guestAppUrl');
        }
    } catch (e) { /* noop */ }
}
purgeStaleStorage();

function captureQueryParamOnce() {
    if (typeof window === 'undefined') return;
    try {
        const fromQuery = new URLSearchParams(window.location.search).get('guestAppUrl');
        if (fromQuery) {
            localStorage.setItem('guestAppUrl', fromQuery.replace(/\/+$/, ''));
        }
    } catch (e) { /* noop */ }
}
captureQueryParamOnce();

export function getGuestAppBaseURL() {
    if (typeof window === 'undefined') return '';

    const fromQuery = new URLSearchParams(window.location.search).get('guestAppUrl');
    if (fromQuery) {
        const v = fromQuery.replace(/\/+$/, '');
        try { localStorage.setItem('guestAppUrl', v); } catch (e) {}
        return v;
    }

    const fromStorage = localStorage.getItem('guestAppUrl');
    if (fromStorage) return fromStorage.replace(/\/+$/, '');

    const derived = deriveFromHost();
    if (derived) return derived;

    if (process.env.REACT_APP_GUEST_APP_BASE_URL) {
        return process.env.REACT_APP_GUEST_APP_BASE_URL.replace(/\/+$/, '');
    }

    return process.env.REACT_APP_NODE_ENV === 'production'
        ? 'https://mi.vserve-protecht.com'
        : 'https://dev.d3jhca2vwfysp4.amplifyapp.com';
}

export function clearGuestAppOverride() {
    try { localStorage.removeItem('guestAppUrl'); } catch (e) {}
}
